import React from "react";

import "./checkbox.scss";

/*
 * Types
 */

export type CheckBoxProps = React.InputHTMLAttributes<HTMLInputElement>;

/*
 * Main
 */

export const CheckBox = (props: CheckBoxProps): React.ReactElement => {
    const { checked, children, ...rest } = props;

    return (
        <label className="checkbox-label">
            <input checked={checked} readOnly type="checkbox" {...rest} />
            <span className="checkmark" />
            <div className="checkbox-text-wrap">{children}</div>
        </label>
    );
};
